export enum FuelTypeEnum {
  Diesel = 1,
  Gasoline = 2,
  Electric = 3,
}

// 国际化标签映射函数
export const getFuelTypeLabel = (fuelType: FuelTypeEnum, t: (key: string) => string): string => {
  const labelMap: Record<FuelTypeEnum, string> = {
    [FuelTypeEnum.Diesel]: t('enum.fuelType.diesel'),
    [FuelTypeEnum.Gasoline]: t('enum.fuelType.gasoline'),
    [FuelTypeEnum.Electric]: t('enum.fuelType.electric'),
  };
  return labelMap[fuelType];
};

// 保留原有的硬编码映射作为后备（可选）
export const FuelTypeLabelMap: Record<FuelTypeEnum, string> = {
  [FuelTypeEnum.Diesel]: 'Diesel',
  [FuelTypeEnum.Gasoline]: 'Gasoline',
  [FuelTypeEnum.Electric]: 'Electric',
}; 